import { createSelector } from 'reselect';
import {
	defaultValuesSelector,
	profileFilterParams,
} from '@src/containers/Filters/selectors';
import { getProfileData } from './getProfileData';

export const getActiveSpecId = createSelector(
	profileFilterParams,
	defaultValuesSelector,
	getProfileData,
	(params, defaultVals, data) => {
		const defaultVal = defaultVals.event ? defaultVals.event[0] : 1;
		const param = params.event ? params.event[0] : defaultVal;
		const targetId = param === 'reset' ? 0 : param;
		const specs = data.spec || [];
		if (!specs.some((i) => i.id === targetId)) {
			const firstSpec = specs[0] || {};
			return firstSpec.id;
		}
		return targetId;
	},
);
